import { Link } from "react-router-dom";
import { services } from "@/data/content";

export default function Footer() {
  return (
    <footer className="bg-ink text-paper border-t border-ink" data-testid="main-footer">
      <div className="px-6 md:px-12 pt-20 pb-24 md:pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8 pb-16 border-b border-paper/15">
          <div className="md:col-span-5">
            <img src="/logo.png" alt="Rogers American Construction logo" className="w-14 h-14 rounded-full mb-6" data-testid="footer-logo-image" />
            <p className="font-display font-medium uppercase tracking-tighter text-3xl md:text-4xl leading-[0.95]">
              Rogers American<br />Construction
            </p>
            <p className="mt-6 text-paper/60 text-sm leading-relaxed max-w-sm">
              A general contractor based in Charleston, serving South Carolina.
              No project too large or small.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.25em] text-paper/40 mb-5">Services</p>
            <ul className="space-y-3">
              {services.map((s) => (
                <li key={s.slug}>
                  <Link
                    to={`/services/${s.slug}`}
                    className="text-sm text-paper/80 hover:text-accent transition-colors"
                    data-testid={`footer-service-${s.slug}`}
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="text-xs uppercase tracking-[0.25em] text-paper/40 mb-5">Company</p>
            <ul className="space-y-3">
              <li><Link to="/residential" className="text-sm text-paper/80 hover:text-accent transition-colors" data-testid="footer-residential-link">Residential Division</Link></li>
              <li><Link to="/request-quote" className="text-sm text-paper/80 hover:text-accent transition-colors" data-testid="footer-quote-link">Request a Quote</Link></li>
              <li><Link to="/request-site-visit" className="text-sm text-paper/80 hover:text-accent transition-colors" data-testid="footer-visit-link">Request a Site Visit</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="text-xs uppercase tracking-[0.25em] text-paper/40 mb-5">Contact</p>
            <ul className="space-y-3 text-sm text-paper/80">
              <li data-testid="footer-address">22 Windermere STE C, Charleston, SC 29412</li>
              <li data-testid="footer-phone">(843) 296-7438</li>
              <li data-testid="footer-email">curt@rogersamerican.com</li>
            </ul>
          </div>
        </div>
        <div className="pt-8 flex flex-col md:flex-row justify-between gap-3 text-xs uppercase tracking-[0.2em] text-paper/40">
          <span>© 2026 Rogers American Construction</span>
          <span>Formerly The Fielding Group · Licensed &amp; Insured</span>
        </div>
      </div>
    </footer>
  );
}
